/**
 * Style/Index Controller
 *
 * 
 */

// the constructor for this object
function StyleIndexController() { }


// the object
StyleIndexController.prototype = {
    constructor: StyleIndexController,
    
    // initialize the controller
    init: function() 
    {
        this._registerCharts();
        
        // setup the box tabs
        var boxTabs = new PortalBoxTabs;
        boxTabs.setupBoxTabs('.box-tabs');
        
        // setup the button tabs
        var buttonTabs = new PortalButtonTabs;
        buttonTabs.init('.button-tabs');
        
        PortalHelper.debugMessage('Style Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Style Controller Ran');
    },
    
    // register the chart objects
    _registerCharts: function()
    {
        // new test line chart
        var LineChart1 = new PortalChart;
        LineChart1.elementId = 'line-chart-1';
        LineChart1.type = 'line';
        LineChart1.dataFormat = 'bytes';
        LineChart1.columns = [
            ['date', 'Date'],
            ['number', 'Production Storage Size']
        ];
        LineChart1.data = this._demoLineData();
        this.LineChart1 = LineChart1;
        
        // new test area chart
        var AreaChart1 = new PortalChart;
        AreaChart1.elementId = 'area-chart-1';
        AreaChart1.type = 'area';
        AreaChart1.dataFormat = 'dollars';
        AreaChart1.columns = [
            ['date', 'Date'],
            ['number', 'Dollars Made'],
            ['number', 'Dollars Lost']
        ];
        AreaChart1.data = this._demoAreaData();
        this.AreaChart1 = AreaChart1;
        
        // new test donut chart
        var DonutChart1 = new PortalChart;
        DonutChart1.elementId = 'donut-chart-1';
        DonutChart1.type = 'donut';
        DonutChart1.dataFormat = 'dollars';
        DonutChart1.data = this._demoDonutData();
        this.DonutChart1 = DonutChart1;
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        
    },
    
    _demoLineData: function()
    {
        var hold = [["Time","Production Storage Size"],[1483312505,665453916157],[1483398906,666015521277],[1483485303,666637109757],[1483571707,666706926077],[1483658103,667099263997],[1483744504,667662535677],[1483830903,668097912317],[1483917304,668013427197],[1484003706,668327912957],[1484090103,667917667837],[1484176507,669746147837],[1484262905,670774960637],[1484349305,671008698877],[1484435705,671008698877],[1484522105,671008698877],[1484608505,671008698877],[1484694906,671008698877],[1484781305,669687229437],[1484867703,670029967357],[1484954104,670295308797],[1485040505,670878887494],[1485126907,670959815677],[1485213305,670936468477],[1485299703,670877788157],[1485386105,671223966717],[1485472504,671532656637],[1485558907,672225333757],[1485645305,672840289277],[1485731704,672863636477],[1485818103,673110438397],[1485904504,674597793277],[1485923704,674597793277],[1485990905,674844897277],[1486077306,671900641277],[1486163704,672363077117],[1486250106,672458969231],[1486336505,672458969231],[1486422904,671801251471],[1486509306,672226006671],[1486682104,676255840911],[1486768506,678163796476],[1486854904,678958612111],[1486941304,678958612111],[1487027706,678806179471],[1487114103,678260474511],[1487200505,678664562465],[1487373304,679419985551],[1487459706,679657550991],[1487546104,679987322511],[1487632506,679972968591],[1487718903,679335513231],[1487805303,679592270991],[1487891706,679734420111],[1487978106,679864196751],[1488064503,680214699882],[1488150906,680325102442],[1488237306,680282529642],[1488323703,682082386282],[1488342903,682790619059],[1488410103,682790619059],[1488496505,680292352362],[1488582905,680328054122],[1488669306,680510308202],[1488755704,680540659562],[1488842103,680349312362],[1488928504,682613560682],[1489014904,685017426647],[1489101304,686235454167],[1489187704,687392279767],[1489274102,687516621527],[1489356907,687592131287],[1489443303,687626230487],[1489529703,687865790898],[1489788906,692692294943],[1489875304,692278803743],[1489961703,692391318303],[1490048105,692547491103],[1490134503,693752111537],[1490220905,694118731697],[1490307304,693668281411],[1490393706,694042249137],[1490480105,694229848497],[1490566504,694286350257],[1490652905,694192510897],[1490739303,695304628292],[1490825704,695148378692],[1490912104,695537846852],[1490998505,695728480543],[1491017704,695728480543],[1491084905,695832534303]];
        
        return hold;
    },
    
    _demoAreaData: function()
    {
        var hold = [
            ["Time", "Dollars Made", "Dollars Lost"]
        ];
        
        var startTimestamp = 1451606400;
        
        for (var i = 0; i < 20; i++) {
            var row = [];
            
            var time = startTimestamp + i * 36000;
            row.push(time);
            
            
            row.push(2000000 * Math.random());
            row.push(-1000000 * Math.random());
            
            hold.push(row);
        }
        
        return hold;
    },
    
    _demoDonutData: function()
    {
        var hold = [
            ['Product', 'Price'],
            ['MPLS',     1100],
            ['Dedicated Internet',      8000],
            ['Virtual Ethernet Service',  12000],
        ];
        
        return hold;
    }
    
}